import React, {useState, memo} from "../../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import _ from "../../../../__snowpack__/pkg/lodash.js";
import {Spin, Modal, Button, Space, Select, Collapse, Table, Tag, Tooltip} from "../../../../__snowpack__/pkg/antd.js";
import {eventLogger} from "../../../lib/eventLogger.js";
import styles from "./index.module.css";
import GnForm from "../../../components/GnForm/index.js";
import {PopoverImg} from "../../../components/PopoverImg/index.js";
import ChannelIcon from "../../../components/ChannelIcon.js";
import {request} from "../../../utils/request/index.js";
import {useCountDown} from "../../../../__snowpack__/pkg/ahooks.js";
const {Panel} = Collapse;
const {Option} = Select;
const MskuRulesModal = memo((props) => {
  const {visible, onHandleCancelCallback} = props;
  const {formatMessage} = useIntl();
  const [form] = GnForm.useForm();
  const [searchForm] = GnForm.useForm();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(true);
  const [optionData, setOptionData] = useState([]);
  const [listSource, setListSource] = useState([]);
  const getListData = async (params) => {
    setLoading(true);
    const data = await request.post("/saas/stock/pushRuleConfig/search/master/variation/list", {
      ...params
    }, {
      handleError: () => {
        setLoading(false);
        setListSource([]);
      }
    });
    setListSource(data);
    setLoading(false);
  };
  const handelMockData = async (params, currentData, currentMasterVariationId) => {
    const data = await request.post("/saas/stock/pushRuleConfig/calculate/stock/strategy", params);
    const {stock = 0, warehouseInventoryStock = 0} = data;
    const currentRow = listSource.map((item) => {
      if (item?.masterVariationId === currentMasterVariationId) {
        const variationItemDetailList = item?.variationItemDetailList.map((variation) => {
          if (variation.channelVariationId === params.channelVariationId) {
            return {
              ...variation,
              mockData: `${warehouseInventoryStock}/${stock}`
            };
          }
          return variation;
        });
        return {...item, variationItemDetailList};
      }
      return item;
    });
    setListSource(currentRow);
  };
  const handleOk = async () => {
    const value = await form.validateFields();
    const mskuList = _.compact(value.rule.split(/\n/).map((item) => item.trim()));
    eventLogger.push({
      action: "ClickViewRules",
      location: "StockPushRules"
    });
    setStep(false);
    setOptionData(mskuList);
    getListData({masterVariationSkuList: mskuList});
  };
  const handleSearch = async () => {
    const formValue = searchForm.getFieldsValue();
    if (formValue.mskuId) {
      getListData({masterVariationSkuList: [formValue.mskuId]});
    } else {
      getListData({masterVariationSkuList: optionData});
    }
  };
  const handleCancel = async () => {
    setStep(true);
    form.resetFields();
    onHandleCancelCallback();
  };
  const RULE_TYPE = {
    DEFAULT: /* @__PURE__ */ React.createElement(Tag, null, formatMessage({id: "Default"})),
    AVAILABLE: /* @__PURE__ */ React.createElement(Tag, {
      color: "#87d068"
    }, formatMessage({id: "storeRule"})),
    CUSTOM_MASTER_SKU: /* @__PURE__ */ React.createElement(Tag, {
      color: "#f50"
    }, formatMessage({id: "specifyMsku"})),
    CUSTOM_SHOP: /* @__PURE__ */ React.createElement(Tag, null, formatMessage({id: "storeRule"}))
  };
  const RULE_STATUS = {
    ENABLE: /* @__PURE__ */ React.createElement(Tag, {
      color: "green"
    }, formatMessage({id: "enable"})),
    DISABLE: /* @__PURE__ */ React.createElement(Tag, {
      color: "red"
    }, formatMessage({id: "Disabled"}))
  };
  const PUSH_TYPE = {
    PROPORTION: formatMessage({id: "proportional"}),
    FIXED: formatMessage({id: "fixedValue"})
  };
  const renderCount = (record) => {
    if (record?.mockData) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, record?.mockData);
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, "-");
  };
  const columns = [
    {
      title: formatMessage({id: "StoreName"}),
      dataIndex: "shopName",
      render: (text, record) => {
        return /* @__PURE__ */ React.createElement("div", {
          style: {display: "inline-flex", alignItems: "center"}
        }, /* @__PURE__ */ React.createElement(ChannelIcon, {
          channelId: record?.channelId
        }), /* @__PURE__ */ React.createElement("span", {
          style: {margin: "0 4px"}
        }, text), /* @__PURE__ */ React.createElement("span", null, record?.countryCode ? `(${record.countryCode})` : null));
      }
    },
    {
      title: formatMessage({id: "channelProductName"}),
      render: (text, record) => {
        return /* @__PURE__ */ React.createElement("div", {
          style: {display: "flex"}
        }, /* @__PURE__ */ React.createElement(PopoverImg, {
          avatarSize: 48,
          previewImage: record.channelVariationImage
        }), /* @__PURE__ */ React.createElement("div", {
          className: styles.productInfo
        }, /* @__PURE__ */ React.createElement(Tooltip, {
          title: record?.channelVariationProductName
        }, /* @__PURE__ */ React.createElement("div", {
          className: styles.productName
        }, record?.channelVariationProductName)), /* @__PURE__ */ React.createElement(Tooltip, {
          title: record?.channelVariationName
        }, /* @__PURE__ */ React.createElement("div", {
          className: styles.productName
        }, record?.channelVariationName)), /* @__PURE__ */ React.createElement(Tooltip, {
          title: record?.channelVariationSku
        }, /* @__PURE__ */ React.createElement("div", {
          className: styles.productName
        }, record?.channelVariationSku))));
      }
    },
    {
      title: formatMessage({id: "menuStockPushRules"}),
      width: 100,
      dataIndex: "ruleName",
      render: (text, record) => {
        return /* @__PURE__ */ React.createElement(Space, {
          direction: "vertical"
        }, /* @__PURE__ */ React.createElement("div", null, text), record?.type ? RULE_TYPE[record.type] : /* @__PURE__ */ React.createElement("span", {
          style: {color: "red"}
        }, "\u65E0\u89C4\u5219"), record?.status ? RULE_STATUS[record.status] : null);
      }
    },
    {
      title: formatMessage({id: "Ruledetails"}),
      width: 160,
      render: (text, record) => {
        let warehouseName = "-";
        if (!_.isEmpty(record?.warehouseList)) {
          warehouseName = record.warehouseList.map((item) => item.name).join("/");
        } else if (record.type === "DEFAULT") {
          warehouseName = "All";
        }
        return /* @__PURE__ */ React.createElement(Space, {
          direction: "vertical"
        }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Tooltip, {
          title: warehouseName
        }, formatMessage({id: "warehouseName1"}), ": ", warehouseName)), /* @__PURE__ */ React.createElement("div", null, formatMessage({id: "pushType"}), ": ", PUSH_TYPE[record?.pushType]), /* @__PURE__ */ React.createElement("div", null, formatMessage({id: "ratioFixValue"}), ":", " ", record?.pushType === "PROPORTION" ? record?.rate : record?.stock));
      }
    },
    {
      title: formatMessage({id: "mskuInventorypushInventory"}),
      width: 150,
      render: (text, record) => {
        return /* @__PURE__ */ React.createElement(Space, {
          direction: "vertical"
        }, /* @__PURE__ */ React.createElement("div", null, record?.isPushStock ? /* @__PURE__ */ React.createElement("span", null, renderCount(record)) : /* @__PURE__ */ React.createElement("span", {
          style: {color: "red"}
        }, formatMessage({id: "noNeedToPush"}))), record?.isPushStock ? /* @__PURE__ */ React.createElement(Countdown, {
          text: formatMessage({id: "analogComputation"}),
          clickCallback: () => {
            const params = {
              masterVariationId: record?.masterVariationId,
              channelVariationId: record?.channelVariationId,
              ruleConfigId: record?.ruleConfigId,
              userRelationId: record?.userRelationId,
              shopId: record?.shopId,
              channelId: record?.channelId
            };
            handelMockData(params, record, record?.masterVariationId);
          }
        }) : null);
      }
    }
  ];
  const MSKU_TYPE = {
    BUNDLE: /* @__PURE__ */ React.createElement(Tag, {
      color: "#108ee9"
    }, formatMessage({id: "combination"})),
    NORMAL: /* @__PURE__ */ React.createElement(Tag, {
      color: "#87d068"
    }, formatMessage({id: "normal"})),
    NO_MSKU: /* @__PURE__ */ React.createElement(Tag, {
      color: "#f50"
    }, formatMessage({id: "mskuDoesNotExist"})),
    NO_PRODUCT: /* @__PURE__ */ React.createElement(Tag, {
      color: "#f50"
    }, formatMessage({id: "unmatchedChannelGoods"}))
  };
  const renderHeader = (item) => {
    let tagType = "";
    if (!item?.masterVariationId) {
      tagType = "NO_MSKU";
    } else {
      if (!item?.variationItemDetailList || _.isEmpty(item?.variationItemDetailList)) {
        tagType = "NO_PRODUCT";
      } else {
        tagType = item.type;
      }
    }
    return /* @__PURE__ */ React.createElement("div", {
      className: styles.listHeader
    }, /* @__PURE__ */ React.createElement("span", null, "MSKU: ", item.masterSku), /* @__PURE__ */ React.createElement("div", {
      style: {marginLeft: "12px"}
    }, MSKU_TYPE[tagType]));
  };
  return /* @__PURE__ */ React.createElement(Modal, {
    visible,
    title: formatMessage({id: "viewMskuApplicationRules"}),
    width: 1080,
    onCancel: handleCancel,
    footer: step && [
      /* @__PURE__ */ React.createElement(Button, {
        onClick: handleCancel
      }, formatMessage({id: "Cancel"})),
      /* @__PURE__ */ React.createElement(Button, {
        type: "primary",
        onClick: handleOk
      }, formatMessage({id: "viewRules"}))
    ]
  }, /* @__PURE__ */ React.createElement("div", {
    className: styles.modalContent
  }, /* @__PURE__ */ React.createElement(Spin, {
    spinning: loading
  }, /* @__PURE__ */ React.createElement("p", {
    className: styles.headTips
  }, formatMessage({id: "promptThisFunctionSupportsViewingThe"})), step ? /* @__PURE__ */ React.createElement(GnForm, {
    form
  }, /* @__PURE__ */ React.createElement(GnForm.Item, {
    componentProps: {
      style: {height: "220px"},
      placeholder: formatMessage({id: "PleaseentertheMSKU"})
    },
    prefabKey: "TextArea",
    rules: [{required: true}],
    name: "rule"
  })) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(GnForm, {
    form: searchForm,
    style: {display: "flex"}
  }, /* @__PURE__ */ React.createElement(GnForm.Item, {
    name: "mskuId"
  }, /* @__PURE__ */ React.createElement(Select, {
    showSearch: true,
    allowClear: true,
    placeholder: "MSKU",
    filterOption: (input, option) => option.children.includes(input),
    style: {width: "300px", marginRight: "12px"}
  }, optionData?.map((item) => /* @__PURE__ */ React.createElement(Option, {
    key: item,
    value: item
  }, item)))), /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    onClick: handleSearch
  }, formatMessage({id: "seacrh"}))), /* @__PURE__ */ React.createElement(Collapse, {
    defaultActiveKey: [0],
    accordion: true
  }, listSource?.map((item, index) => {
    const dataSource = item.variationItemDetailList.map((product) => ({
      ...product,
      masterVariationId: item?.masterVariationId || ""
    }));
    return /* @__PURE__ */ React.createElement(Panel, {
      header: renderHeader(item),
      key: index
    }, /* @__PURE__ */ React.createElement(Table, {
      columns,
      dataSource,
      pagination: false,
      expandable: {
        defaultExpandAllRows: true,
        expandIcon: () => null,
        expandedRowRender: (record) => {
          if (record.message) {
            return /* @__PURE__ */ React.createElement("p", {
              style: {marginLeft: "46px", color: "red", marginTop: "0px", marginBottom: "0px"}
            }, formatMessage({id: "reason"}), ":", record.message);
          }
          return null;
        },
        rowExpandable: (record) => record.message
      }
    }));
  }))))));
});
const Countdown = memo((props) => {
  const {countDownOption = {}, style = {}, text = "", clickCallback = null} = props;
  const [targetDate, setTargetDate] = useState();
  const [countdown] = useCountDown({
    targetDate,
    ...countDownOption
  });
  return /* @__PURE__ */ React.createElement("a", {
    onClick: () => {
      if (countdown === 0) {
        clickCallback && clickCallback();
        setTargetDate(Date.now() + 6e4);
      }
    },
    style
  }, countdown === 0 ? text : /* @__PURE__ */ React.createElement("span", {
    style: {color: "#ADBACC"}
  }, `${text} ( ${Math.round(countdown / 1e3)}s )`));
});
export default MskuRulesModal;
